export function formatAmount(amount: number | string) {
  const cleanedAmount = amount.toString().replace(/\s+/g, '');

  return cleanedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
